
import React from 'react'
import {connect} from "react-redux"

import SelectTherapyCategories from './SelectTherapyCategories.jsx';


import './styles/AdminVideo.scss';
import deleteImage from '../../images/icons/delete_forever_black.svg';


import { adminSaveVideo, adminToggleVideoTherapyArea, adminSaveTherapyArea } from "../../actions/admin"

@connect((store) => {
	return {
		therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories
	}
})
class AdminVideo extends React.Component {
  constructor(props) {
		super(props);
    this.edit = this.edit.bind(this);
    this.save = this.save.bind(this);
    this.editOptions = this.editOptions.bind(this);
    this.displayOptions = this.displayOptions.bind(this);
    this.handleItemChange = this.handleItemChange.bind(this);
		this.checked = this.checked.bind(this)
		this.handleAreaClick = this.handleAreaClick.bind(this);
    this.state = {
      editing:false,
      item: this.props.item
    }
  }


  save(){
		//save video
		this.props.dispatch(adminSaveVideo(this.state.item));

		// save therapy areas associated to this Video
		Object.values(this.props.therapy_areas)
			.forEach(area => {
				this.props.dispatch(adminSaveTherapyArea(area));
			})

    this.edit();
  }

  handleItemChange(e, field){
    let item = this.state.item;
		item[field] = e.target.value;
		this.setState({item: item})
  }

  edit(){
    this.setState({
      'editing': !this.state.editing
    });
  }

  editOptions(){
    if(this.state.editing){
      return <div>
        <button className="md-button md-accent md-raised link" onClick={this.save} >Save</button>
        &nbsp;  <a className="link" onClick={this.edit}>Cancel</a>
      </div>;
    }else{
      return <div>
        <a className="link" onClick={this.edit}>Edit</a>
      </div>;
    }
  }
	checked(area ){
		return area.videos.indexOf(this.state.item._id) !== -1
	}

  displayOptions(){
     let { selectPracticeType } = this.props;

    if(this.state.editing){
      return (
        <div>
          <h6 className="md-subhead">
            <input
              className="md-input md-title"
              onChange={e => this.handleItemChange(e, "name")}
              value={this.state.item.name}
              type="text"
              placeholder="Video title"
            />
          </h6>
          <textarea
            className="md-input multiple"
            value={this.state.item.description}
            placeholder="Video description"
            onChange={e => this.handleItemChange(e, "description")}
          />
          <br />

          <br />
          <b>Therapy Areas</b>
          <SelectTherapyCategories
            checkedCond={this.checked}
            typeSelected={selectPracticeType}
            click={this.handleAreaClick}
          />
          
          <br />
          <br />
          <br />
        </div>
      );
    }else{
      return <div>
				<div className="card-content">
					<h6 className='md-subhead'>{this.props.item.name}</h6>
					<p>{this.props.item.description}</p>
				</div>
      </div>;
    }
  }

	handleAreaClick(area){
		this.props.dispatch(adminToggleVideoTherapyArea(area, this.props.item._id));
	}

  render () {
    return <div className={"card marginless admin-video " + (this.state.editing? 'editing' : '')} >
			<div >
						{
							this.state.editing ? <iframe width="100%" height="100%"
							allowFullScreen="allowfullscreen"
							className="youtube-frame"
							src={`https://www.youtube.com/embed/${this.state.item.code}?autoplay=0`}
							/>
						:
						<img alt="Youtube pic" src={`https://img.youtube.com/vi/${this.props.item.code}/0.jpg`} width="100%" />
						}
			</div>
			<div className="card-content">
	      {this.displayOptions()}
			</div>
      <div className="component-footer reading">
        {this.editOptions()}
        <div onClick={() => {
						this.props.handleDelete(this.props.item._id)
					}} className="delete"><img src={deleteImage} alt="Delete" /></div>
      </div>
    </div>
  }
}

export default AdminVideo;



// WEBPACK FOOTER //
// ./src/components/admin/AdminVideo.jsx